import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function RuleBlock({
  title,
  description,
  buttonText,
  buttonSx,
  onClickButton,
  onClear,
  children,
}) {
  const isSelected = Boolean(onClear);

  return (
    <Box sx={{ mb: 4 }}>
      <Typography sx={{ fontSize: 14, fontWeight: 600, mb: 1 }}>
        {title}
      </Typography>

      <Typography sx={{ fontSize: 13, color: "custom.gray.600", mb: 2 }}>
        {description}
      </Typography>

      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={2}
        alignItems="stretch"
      >
        <Box
          sx={{
            width: { xs: "100%", md: 320 },
            flexShrink: 0,
          }}
        >
          <Button
            fullWidth
            variant="contained"
            onClick={onClickButton}
            sx={{
              ...buttonSx,

              display: "flex",
              alignItems: "center",
              gap: 1,
              height: 56,
              minWidth: 0,
              width: "100%",
              maxWidth: "100%",
              overflow: "hidden",

              ...(isSelected && {
                color: "#fff",
              }),
 
              "&:hover": {
                color: "#fff",
              },
            }}
          >
            <Box
              sx={{
                flex: 1,
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {buttonText}
            </Box>

            {isSelected && (
              <Box
                onClick={(e) => {
                  e.stopPropagation();
                  onClear();
                }}
                sx={{
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  cursor: "pointer",

                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.15)",
                  },
                }}
              >
                <CloseIcon sx={{ fontSize: 18, color: "inherit" }} />
              </Box>
            )}
          </Button>
        </Box>

        {children}
      </Stack>
    </Box>
  );
}
